module.exports = __webpack_public_path__ + "img/undraw_Page_not_found_re_e9o6.134fdf73.png";